import layout from '@/layout'

export default {
  path: '/supply',
  component: layout,
  redirect: '/supply/goods',
  name: 'supply',
  meta: {
    title: '供应链（集团管理)',
    icon: 'supply'
  },
  children: [
    {
      path: '/supply/goods',
      name: 'supply_index',
      component: () => import('@/views/supply/supply-goods.vue'),
      meta: {
        title: '供应链管理',
        icon: 'supply'
      }
    }
  ]
}
